import React, {useState} from "react";
import stilePulsanti from "../../interfaccia/stilePulsanti";

function Anteprima({
    snippet,
    anteprima,
    i
}) {

    let className = "pa3 sfondoBiancoTema br3 ma3 anteprimaMenuSito"
                    
    if (i % 2 == 0) {
        className = className+" ba bg-white"
    }  

    const [classHtml, setClassHtml] = useState("pointer dib")

      
          
    if (anteprima) {
        return <div className={className}>
            <p dangerouslySetInnerHTML={{__html: snippet}}></p>
        </div>
    } else {
        return <div className="">
            <p className={classHtml} onClick={(e) => {
                e.preventDefault()
                setClassHtml(classHtml+" green b")
                navigator.clipboard.writeText(snippet)
                .then(e.preventDefault())
                }}>{snippet}</p>
        </div>
    }    
}

export default Anteprima;



